module.exports = __webpack_public_path__ + "static/img/office_01.35ee85a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/office_01.png
// module id = z7o6
// module chunks = 0